/* Small, dependency-free storefront polish that degrades cleanly without JavaScript. */
(function () {
  'use strict';

  var goodDeedStories = [
    'https://www.goodnewsnetwork.org/garbage-workers-in-italy-help-woman-find-her-million-jackpot/',
    'https://www.goodnewsnetwork.org/towns-beloved-santa-claus-delivers-a-very-special-present-to-someone-in-need-his-donated-kidney/',
    'https://www.goodnewsnetwork.org/after-stranger-gives-boy-a-piano-a-mozart-level-is-revealed-in-spite-of-autism/',
    'https://www.goodnewsnetwork.org/midwest-stranger-lends-his-truck-to-band-with-broken-down-van/',
    'https://www.goodnewsnetwork.org/woman-wins-lottery-and-immediately-gives-neighbor-5000-for-family-vacation/',
    'https://www.goodnewsnetwork.org/just-by-mowing-a-lawn-social-media-star-raises-685000-for-bereaved-senior-who-fell-behind-on-rent/',
    'https://www.goodnewsnetwork.org/community-spares-no-effort-to-reunite-lost-dog-with-owner-after-their-car-was-rolled-in-a-crash/',
    'https://www.goodnewsnetwork.org/free-ice-cream-gift-for-one-child-prompts-donations-to-fund-free-sweets-for-all-kids-the-entire-summer/'
  ];

  function activateGoodDeedStories() {
    document.querySelectorAll('[data-gd-random-story]').forEach(function (link) {
      if (!link || !link.dataset || link.dataset.gdStoryReady === 'true') return;
      link.dataset.gdStoryReady = 'true';
      link.href = goodDeedStories[Math.floor(Math.random() * goodDeedStories.length)];
      link.addEventListener('click', function () {
        try {
          link.dispatchEvent(new CustomEvent('good-deeds:story-opened', {
            bubbles: true,
            detail: { url: link.href, source: 'Good News Network' }
          }));
        } catch (error) {
          // Reading a good story should never depend on a connected integration.
        }
      });
    });
  }

  function activateFinder(root) {
    if (!root || root.dataset.gdFinderReady === 'true') return;
    root.dataset.gdFinderReady = 'true';

    root.addEventListener('click', function (event) {
      var option = event.target.closest('[data-gd-finder-option]');
      if (!option || !root.contains(option)) return;

      root.querySelectorAll('[data-gd-finder-option]').forEach(function (candidate) {
        var selected = candidate === option;
        candidate.classList.toggle('is-selected', selected);
        candidate.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });

      var copy = root.querySelector('[data-gd-finder-copy]');
      var link = root.querySelector('[data-gd-finder-link]');
      if (copy) copy.textContent = option.dataset.finderCopy || '';
      if (link && option.dataset.finderUrl) link.href = option.dataset.finderUrl;

      try {
        root.dispatchEvent(
          new CustomEvent('good-deeds:discovery-selected', {
            bubbles: true,
            detail: { department: option.dataset.finderDepartment, url: option.dataset.finderUrl }
          })
        );
      } catch (error) {
        // External integrations should never interrupt the storefront.
      }
    });
  }

  function activateShelterImpact(element) {
    if (!element || !element.dataset || !element.dataset.gdDonationBaseCents || element.dataset.gdImpactReady === 'true') return;
    element.dataset.gdImpactReady = 'true';
    try {
      element.dispatchEvent(new CustomEvent('good-deeds:shelter-impact-calculated', {
        bubbles: true,
        detail: {
          baseCents: Number(element.dataset.gdDonationBaseCents),
          pledgedCents: Number(element.dataset.gdDonationPledgeCents),
          percentage: Number(element.dataset.gdDonationRate),
          currency: element.dataset.gdDonationCurrency,
          scope: element.dataset.gdDonationScope,
          beneficiary: element.dataset.gdDonationBeneficiary
        }
      }));
    } catch (error) {
      // The visible pledge must remain correct even if an external integration fails.
    }
  }

  function activateDirectDonation(root) {
    if (!root || !root.dataset || !root.dataset.gdDonationVariant || root.dataset.gdDirectDonationReady === 'true') return;
    root.dataset.gdDirectDonationReady = 'true';
    root.addEventListener('click', function (event) {
      var option = event.target.closest('[data-gd-donation-quantity]');
      if (!option || !root.contains(option)) return;
      var quantity = Number(option.dataset.gdDonationQuantity);
      if (!Number.isInteger(quantity) || quantity < 1 || quantity > 500) return;
      root.querySelectorAll('[data-gd-donation-quantity]').forEach(function (candidate) {
        var selected = candidate === option;
        candidate.classList.toggle('is-selected', selected);
        candidate.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
      var checkout = root.querySelector('[data-gd-donation-checkout]');
      var label = root.querySelector('[data-gd-donation-amount]');
      var amountCents = Number(root.dataset.gdDonationUnitCents) * quantity;
      if (checkout) checkout.href = root.dataset.gdDonationCartUrl + '/' + root.dataset.gdDonationVariant + ':' + quantity;
      if (label) {
        try {
          label.textContent = new Intl.NumberFormat(undefined, { style: 'currency', currency: root.dataset.gdDonationCurrency || 'USD' }).format(amountCents / 100);
        } catch (error) {
          label.textContent = (amountCents / 100).toFixed(2);
        }
      }
      try {
        root.dispatchEvent(new CustomEvent('good-deeds:donation-amount-selected', {
          bubbles: true,
          detail: { amountCents: amountCents, quantity: quantity, currency: root.dataset.gdDonationCurrency, checkoutUrl: checkout && checkout.href }
        }));
      } catch (error) {
        // Separate donation checkout remains usable when app integrations are unavailable.
      }
    });
  }

  function activateCharitySelector(root) {
    if (!root || !root.dataset || !root.dataset.gdCartUpdateUrl || root.dataset.gdCharityReady === 'true') return;
    root.dataset.gdCharityReady = 'true';
    root.addEventListener('click', function (event) {
      var option = event.target.closest('[data-gd-charity-option]');
      if (!option || !root.contains(option)) return;
      var name = option.dataset.charityName || '';
      var ein = option.dataset.charityEin || '';
      var focus = option.dataset.charityFocus || 'Animal welfare';
      var directUrl = /^https:\/\//.test(option.dataset.charityUrl || '') ? option.dataset.charityUrl : '';
      if (!name) return;

      root.querySelectorAll('[data-gd-charity-option]').forEach(function (candidate) {
        var selected = candidate === option;
        candidate.classList.toggle('is-selected', selected);
        candidate.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
      root.dataset.gdSelectedCharity = name;
      document.querySelectorAll('[data-gd-beneficiary-name]').forEach(function (label) { label.textContent = name; });
      document.querySelectorAll('[data-gd-beneficiary-ein]').forEach(function (label) { label.textContent = 'EIN ' + ein; });
      document.querySelectorAll('[data-gd-beneficiary-focus]').forEach(function (label) { label.textContent = focus; });
      document.querySelectorAll('[data-gd-shelter-impact]').forEach(function (impact) { impact.dataset.gdDonationBeneficiary = name; });

      var directLink = root.querySelector('[data-gd-selected-charity-donate]');
      var directName = root.querySelector('[data-gd-selected-charity-name]');
      var directNote = root.querySelector('[data-gd-charity-direct-note]');
      if (directName) directName.textContent = name;
      if (directLink) {
        directLink.hidden = !directUrl;
        if (directUrl) directLink.href = directUrl;
      }
      if (directNote) directNote.hidden = Boolean(directUrl);

      var status = root.querySelector('[data-gd-charity-status]');
      if (status) status.textContent = 'Saving ' + name + ' to your Shopify cart…';
      var attributes = {
        'Good Deeds charity': name,
        'Good Deeds charity EIN': ein,
        'Good Deeds pledge': '10% of order'
      };
      try {
        root.dispatchEvent(new CustomEvent('good-deeds:charity-selected', {
          bubbles: true,
          detail: { charity: name, ein: ein, focus: focus, pledgePercent: 10, directDonationUrl: directUrl }
        }));
      } catch (error) {
        // Shopify cart persistence remains independent from connected integrations.
      }
      if (typeof fetch !== 'function') {
        if (status) status.textContent = 'Selected: ' + name + '. It will be saved when the Shopify cart is available.';
        return;
      }
      fetch(root.dataset.gdCartUpdateUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: attributes })
      }).then(function (response) {
        if (!response.ok) throw new Error('Shopify cart update failed');
        return response.json();
      }).then(function () {
        if (status) status.textContent = 'Selected: ' + name + '. Saved with your Shopify cart and checkout.';
        try {
          root.dispatchEvent(new CustomEvent('good-deeds:charity-selection-saved', {
            bubbles: true,
            detail: { charity: name, ein: ein, pledgePercent: 10, savedToCart: true }
          }));
        } catch (error) {
          // A saved Shopify selection does not depend on analytics.
        }
      }).catch(function () {
        if (status) status.textContent = 'Selected: ' + name + '. Please choose it again from your cart before checkout.';
      });
    });
  }

  function activateCartReminder(root) {
    if (!root || !root.dataset || !('gdCartReminderRoot' in root.dataset) || root.dataset.gdCartReminderReady === 'true') return;
    var form = root.querySelector('.gd-cart-reminder__form');
    if (!form) return;
    root.dataset.gdCartReminderReady = 'true';

    form.addEventListener('submit', function () {
      var consent = form.querySelector('[data-gd-cart-reminder-consent]');
      var email = form.querySelector('[data-gd-cart-reminder-email]');
      if (!consent || !consent.checked || !email || !email.validity || !email.validity.valid) return;

      try {
        root.dispatchEvent(new CustomEvent('good-deeds:cart-reminder-requested', {
          bubbles: true,
          detail: {
            items: Number(root.dataset.gdCartCount),
            cartTotalCents: Number(root.dataset.gdCartTotal),
            currency: root.dataset.gdCartCurrency || 'USD',
            source: 'shopify-customer-consent-form',
            emailProvided: true
          }
        }));
      } catch (error) {
        // Shopify's native email-consent form must work without third-party integrations.
      }
    });
  }

  function activateRewardProgress(root) {
    if (!root || !root.dataset || !('gdRewardProgress' in root.dataset)) return;
    var prize;
    try {
      prize = JSON.parse(localStorage.getItem('good-deeds-rewards-prize-v1') || 'null');
    } catch (error) {
      prize = null;
    }
    if (!prize || !prize.code) {
      root.hidden = true;
      return;
    }

    var total = Math.max(0, Number(root.dataset.cartTotalCents || 0) / 100);
    var minimum = Math.max(0, Number(prize.minimum) || 0);
    var remaining = Math.max(0, minimum - total);
    var progress = minimum > 0 ? Math.min(100, total / minimum * 100) : 100;
    var type = prize.type === 'shipping' ? 'shipping' : 'percentage';
    var rewardName = type === 'shipping' ? 'Free shipping' : String(Number(prize.percentage) || 0) + '% off';
    var currency = root.dataset.currency || 'USD';
    var title = root.querySelector('[data-gd-reward-progress-title]');
    var message = root.querySelector('[data-gd-reward-progress-message]');
    var fill = root.querySelector('[data-gd-reward-progress-fill]');
    var progressbar = root.querySelector('[role="progressbar"]');
    var apply = root.querySelector('[data-gd-reward-progress-apply]');

    function formatMoney(amount) {
      try {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency, maximumFractionDigits: 2 }).format(amount);
      } catch (error) {
        return '$' + amount.toFixed(2);
      }
    }

    if (title) title.textContent = rewardName;
    if (fill) fill.style.width = progress + '%';
    if (progressbar) progressbar.setAttribute('aria-valuenow', String(Math.round(progress)));
    if (message) {
      message.textContent = remaining > 0
        ? 'Add ' + formatMoney(remaining) + ' more to use this reward.'
        : rewardName + ' is ready for Shopify to validate at checkout.';
    }
    if (apply) {
      apply.href = '/discount/' + encodeURIComponent(prize.code) + '?redirect=' + encodeURIComponent(root.dataset.cartUrl || '/cart');
      apply.textContent = remaining > 0 ? 'Keep shopping' : 'Apply reward';
      if (remaining > 0) apply.href = root.dataset.shopUrl || '/collections/all?sort_by=best-selling';
    }
    root.hidden = false;
  }

  function activateAppearanceToggle(button) {
    if (!button || !button.dataset || !('gdThemeToggle' in button.dataset) || button.dataset.gdThemeReady === 'true') return;
    button.dataset.gdThemeReady = 'true';

    function reflectAppearance(mode) {
      var isDark = mode === 'dark';
      button.setAttribute('aria-pressed', isDark ? 'true' : 'false');
      button.setAttribute('aria-label', isDark ? 'Switch to light mode' : 'Switch to dark mode');
      var label = button.querySelector('[data-gd-theme-label]');
      var icon = button.querySelector('[data-gd-theme-icon]');
      if (label) label.textContent = isDark ? 'Light mode' : 'Dark mode';
      if (icon) icon.textContent = isDark ? '☼' : '☾';
    }

    reflectAppearance(document.documentElement.dataset.gdTheme || 'dark');
    button.addEventListener('click', function () {
      var current = document.documentElement.dataset.gdTheme === 'light' ? 'light' : 'dark';
      var next = current === 'dark' ? 'light' : 'dark';
      document.documentElement.dataset.gdTheme = next;
      document.documentElement.style.colorScheme = next;
      reflectAppearance(next);
      try { localStorage.setItem('good-deeds-appearance-dark-default', next); } catch (error) {}
      try {
        button.dispatchEvent(new CustomEvent('good-deeds:appearance-changed', {
          bubbles: true,
          detail: { appearance: next, previous: current }
        }));
      } catch (error) {
        // A shopper's preferred appearance never depends on external integrations.
      }
    });
  }

  function activateDonationTotal(root) {
    if (!root || root.dataset.gdDonationTotalReady === 'true') return;
    root.dataset.gdDonationTotalReady = 'true';

    function renderTotal(rawValue) {
      var value = Math.max(0, Number(rawValue) || 0);
      var goal = Math.max(1, Number(root.dataset.gdTotalDonationsGoal) || 100000);
      var progress = Math.min(100, value / goal * 100);
      var amount = root.querySelector('.gd-donation-total__amount strong, .gd-shelter-scale__amount strong');
      var progressbar = root.querySelector('[role="progressbar"]');
      var fill = root.querySelector('.gd-donation-total__slider > span');
      var marker = root.querySelector('.gd-donation-total__slider > i');
      var percentage = root.querySelector('.gd-donation-total__footer strong');
      if (amount) amount.textContent = new Intl.NumberFormat(undefined, { style: 'currency', currency: 'USD', maximumFractionDigits: 2 }).format(value);
      if (progressbar) progressbar.setAttribute('aria-valuenow', String(Math.min(value, goal)));
      if (fill) fill.style.setProperty('--gd-donation-progress', progress + '%');
      if (fill) fill.style.width = progress + '%';
      if (marker) marker.style.setProperty('--gd-donation-progress', progress + '%');
      if (percentage) percentage.textContent = progress.toFixed(1).replace('.0', '') + '%';
      root.dataset.gdTotalDonationsValue = String(value);
    }

    document.addEventListener('good-deeds:donation-total-updated', function (event) {
      if (event.detail && Number.isFinite(Number(event.detail.totalDollars))) renderTotal(event.detail.totalDollars);
    });
  }

  function activateCartDock(root) {
    if (!root || root.dataset.gdCartDockReady === 'true') return;
    root.dataset.gdCartDockReady = 'true';
    var badge = root.querySelector('[data-gd-cart-count]');
    if (!badge) return;

    function reflectCartCount(rawCount) {
      var count = Math.max(0, Number.parseInt(rawCount, 10) || 0);
      badge.textContent = count > 99 ? '99+' : String(count);
      badge.hidden = count === 0;
      root.setAttribute('aria-label', count > 0 ? 'View cart, ' + count + (count === 1 ? ' item' : ' items') : 'View cart');
    }

    reflectCartCount(root.dataset.initialCartCount);
    var headerCount = document.querySelector('cart-icon [data-testid="cart-bubble"]');
    if (headerCount && typeof MutationObserver === 'function') {
      var synchronize = function () {
        reflectCartCount(headerCount.dataset.cartCount || headerCount.textContent.trim());
      };
      synchronize();
      new MutationObserver(synchronize).observe(headerCount, {
        childList: true,
        characterData: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'data-cart-count']
      });
      window.addEventListener('pageshow', synchronize);
    }

    root.addEventListener('click', function (event) {
      var drawerTrigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
      if (!drawerTrigger || document.body.classList.contains('template-cart')) return;
      event.preventDefault();
      drawerTrigger.click();
    });
  }

  function activateSaleCountdown(root) {
    if (!root || root.dataset.gdCountdownReady === 'true') return;
    root.dataset.gdCountdownReady = 'true';
    var deadlineText = root.dataset.saleEnd || '';
    if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2})?(?:Z|[+-]\d{2}:\d{2})$/.test(deadlineText)) return;
    var deadline = Date.parse(deadlineText);
    if (!Number.isFinite(deadline) || deadline <= Date.now()) return;

    var dateLabel = root.querySelector('[data-gd-sale-local-date]');
    if (dateLabel) {
      dateLabel.dateTime = new Date(deadline).toISOString();
      try {
        dateLabel.textContent = new Intl.DateTimeFormat(undefined, { dateStyle: 'medium', timeStyle: 'short' }).format(deadline);
      } catch (error) {
        dateLabel.textContent = new Date(deadline).toLocaleString();
      }
    }

    var timer;
    function updateClock() {
      var remaining = deadline - Date.now();
      if (remaining <= 0) {
        root.hidden = true;
        if (timer) window.clearInterval(timer);
        return;
      }
      var totalSeconds = Math.floor(remaining / 1000);
      var values = {
        days: Math.floor(totalSeconds / 86400),
        hours: Math.floor(totalSeconds / 3600) % 24,
        minutes: Math.floor(totalSeconds / 60) % 60,
        seconds: totalSeconds % 60
      };
      Object.keys(values).forEach(function (unit) {
        var element = root.querySelector('[data-gd-countdown-' + unit + ']');
        if (element) element.textContent = String(values[unit]).padStart(2, '0');
      });
      root.hidden = false;
    }

    updateClock();
    timer = window.setInterval(updateClock, 1000);
    document.addEventListener('shopify:section:unload', function (event) {
      if (event.target && event.target.contains(root)) window.clearInterval(timer);
    });
  }

  function activateAll() {
    document.querySelectorAll('[data-gd-finder]').forEach(activateFinder);
    activateGoodDeedStories();
    document.querySelectorAll('[data-gd-shelter-impact]').forEach(activateShelterImpact);
    document.querySelectorAll('[data-gd-direct-donation]').forEach(activateDirectDonation);
    document.querySelectorAll('[data-gd-charity-selector]').forEach(activateCharitySelector);
    document.querySelectorAll('[data-gd-cart-reminder-root]').forEach(activateCartReminder);
    document.querySelectorAll('[data-gd-reward-progress]').forEach(activateRewardProgress);
    document.querySelectorAll('[data-gd-theme-toggle]').forEach(activateAppearanceToggle);
    document.querySelectorAll('[data-gd-total-donations]').forEach(activateDonationTotal);
    document.querySelectorAll('[data-gd-cart-dock]').forEach(activateCartDock);
    document.querySelectorAll('[data-gd-sale-countdown]').forEach(activateSaleCountdown);
  }

  activateAll();
  document.addEventListener('shopify:section:load', activateAll);
  document.addEventListener('good-deeds:reward-awarded', activateAll);
  document.addEventListener('cart:update', function () { window.setTimeout(activateAll, 0); });
})();
